import React from "react";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../components/detailWrapper";
import { Button } from "semantic-ui-react";
import { AiFillCheckCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import ResultPage from "../../components/ResultPage/ResultPage";

const WithdrawSuccess = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`formHint.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const navigate = useNavigate();

  return (
    <ResultPage
      buttonProps={{
        content: i18n("goToDepositData"),
        path: "../../profile/transaction",
      }}
      resultContent={`${i18n("youCanGo")} ${i18n("depositRoute")}，${i18n(
        "view"
      )}
    ${i18n("depositData")}`}
      resultText={i18n("withdrawSuccess")}
      pageType="success"
      pageTitle={i18n("withdrawSuccess")}
    />
  );
};

export default WithdrawSuccess;
